var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"color":"blue"},on:{"update:active":function($event){_vm.loading=$event}}})],1),_c('AppHeader'),_c('AppNavigation'),_c('AppContent'),_c('AppFooter'),_vm._v(" "+_vm._s(this.loading)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }